<template>
  <v-btn stacked v-if="isAdmin" @click="goToSupport" class="top-nav-icon">
    <v-icon>mdi-account-hard-hat-outline</v-icon>
  </v-btn>
</template>
<script setup>
import { useRootStore } from '../../stores/root';
import { storeToRefs } from 'pinia';

const store = useRootStore();
const { isAdmin } = storeToRefs(store);

function goToSupport() {
  const { origin, pathname } = window.location;

  if (pathname.startsWith('/support/')) return;

  window.location.assign(`${origin}/support/`);
}
</script>
